import styled from 'styled-components';
import Box from '../../base/Box';

export const StyledSplitPane = styled.div`
  width: ${({ width }) => {
    if (typeof width === 'string' && width.endsWith('%')) {
      return `${width}`;
    }
    return `${width}px`;
  }};
  height: ${({ height }) => height}px;
  position: relative;
`;

export const Resizer = styled.div`
  display: flex;
  cursor: grab;
  height: 30px;
  width: 100%;
  align-items: center;
  justify-content: center;
  background: transparent;
  color: ${({ theme }) => theme.colors.secondaryLink};

  border-bottom: ${({ showBorder = false, theme }) => {
    if (!showBorder) {
      return 0;
    }
    return `1px solid ${theme.colors.heavyLineOutline}`;
  }};
`;

export const PaneContainer = styled(Box).attrs({
  width: '100%',
  height: '100%',
})`
  pointer-events: ${({ isDragging }) => (isDragging ? 'none' : 'auto')};
`;
